/**
 * Mapbox 地图使用打点常量定义
 */

/**
 * 打点时机枚举
 */
export enum MapBoxTrackingTime {
  /** 地图加载时打点（对应 Mapbox 的 Map Load） */
  MAP_LOAD = 'map_load'
}


/**
 * 页面标识符常量
 * 统一的页面标识符定义，避免魔法值
 */
export enum MapBoxPageMarker {
  /** 揽收地图模式页面 */
  PICKUP_MAP_MODE = 'pickup_map_mode',
  /** 揽收订单详情页面 */
  PICKUP_ORDER_DETAIL = 'pickup_order_detail',
  /** 派送地图模式页面 */
  DELIVERY_MAP_MODE = 'delivery_map_mode',
  /** 派送订单详情页面 */
  DELIVERY_ORDER_DETAIL = 'delivery_order_detail',
  /** DSP地图模式基础标识 */
  DSP_MAP_MODE = 'dsp_map_mode',
  /** DSP任务明细页面 */
  DSP_TASK_DETAIL = 'dsp_task_detail',
  /** 错误页面标识 */
  ERROR_PAGE = 'error_page'
}


